import { isFilled } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";

/**
 * @typedef {import("@prismicio/client").Content.BannerImageSlice} BannerImageSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BannerImageSlice>} BannerImageProps
 * @type {import("react").FC<BannerImageProps>}
 */
const BannerImage = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="border-t-[0.5px] border-graphite"
    >
      <div className="w-full">
        {/* Image desktop */}
        {isFilled.image(slice.primary.img) && (
          <div className="hidden md:block w-full max-h-67">
            <PrismicNextImage
              field={{
                ...slice.primary.img,
                alt: slice.primary.img.alt || "Image d'illustration"
              }}
              className="w-full h-auto max-h-67 object-cover"
            />
          </div>
        )}

        {/* Image mobile */}
        {isFilled.image(slice.primary.img_mobile) && (
          <div className="block md:hidden w-full max-h-50">
            <PrismicNextImage
              field={{
                ...slice.primary.img_mobile,
                alt: slice.primary.img_mobile.alt || "Image d'illustration"
              }}
              className="w-full hobject-cover h-50"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default BannerImage;
